import React, { Component } from 'react';
import { Grid, Avatar } from '@material-ui/core';

import LoactionMap from './locationMap';


const defaultProps = {
  center: {
    lat: 21.1471642,
    lng: 72.6897491
  },
  zoom: 12,
  avater: {
    marginTop: 0
  },
  desc: {
    margin: '5px 0 0 0',
    borderBottom: '2px solid #a9a9a9',
    // padding: '8px',
    color: '#000'
  },
  address: {
    margin: '0',
    color: '#a9a9a9'
  },
  para: {
    width: '100%',
    margin: '0',
    fontSize: '15px',
    fontWeight: 'bold'
  },
  span: {
    float: 'right'
  },
  wdh: {
    width: '100%'
  },
  info: {
    textAlign: 'center',
    display: 'flex',
    width: '200px'
  },
  infoAvatar: {
    backgroundColor: '#000'
  },
  infoOffer: {
    fontWeight: 'bold',
    fontSize: '15px'
  }

}

class DealSearch extends Component {
  constructor(){
    super();
    this.state={
      dist:0,
      deals:{}
    }
  }
  componentDidMount(){
    let {deals}=this.props;
    this.setState({deals:deals});
    this.getLocation();
  }
  checkProfileImg=(url)=>{
    const {user}=this.props;
    if(url=== null || url==="" ){
      return <img  src={require(`../../../images/Alphabets/${user.results.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)} height={50} width={50}/>
    }else{
      return <img src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${url}`} height={50} width={50}/>
    }
  };
  formatAddress=(address)=>{
    let arr=[];
    (address.split(',')).forEach((ad,i)=>{
      if(i<address.split(',').length-1){
        arr.push(ad);
      }
    });
   return arr.join(",");
  }
  getLocation=()=> {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.showPosition);
    }
  }
  showPosition=(position)=> {
    let { user }=this.props;
   let lat= position.coords.latitude;
   let long=position.coords.longitude;
   this.calculateDistance(lat,long,user.results.BusinessUser.Address_Lat,user.results.BusinessUser.Address_Long);
  }
  calculateDistance=(lat1, lon1, lat2, lon2, unit)=>{
      var radlat1 = Math.PI * lat1/180
      var radlat2 = Math.PI * lat2/180
      var theta = lon1-lon2
      var radtheta = Math.PI * theta/180
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist)
      dist = dist * 180/Math.PI
      dist = dist * 60 * 1.1515
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      this.setState({dist:(dist*0.621371).toFixed(2)})
  }
  render () {
    let {user}=this.props;
    let {deals}=this.props;
    return (
      <div>
        <div className="live-preview-text">
          Live preview of how your deals will appear in search results
        </div>
        <div>
          <Grid container spacing={24}>
            <Grid item sm={12} xs={12} md={6} style={{width: '100%'}}>
              <div style={{position: 'relative'}}>
              <LoactionMap mapData={{width:'410px',height:'287px'}} user={user} deals={deals}/>
              </div>
            </Grid>
            <Grid item sm={12} xs={12} md={6} style={defaultProps.divBorder}>
              <div className="result" style={defaultProps.wdh}>
                <div>
                  <Avatar className="avatar-search">
                    {this.checkProfileImg(user.results.AppUser.ProfileImage)}
                  </Avatar>
                </div>
                <div style={defaultProps.wdh}>
                  {/*<div className="result">*/}
                    {/*<p style={defaultProps.para}>{user.results.BusinessUser.Businessname}</p>*/}
                    {/*<p style={defaultProps.para}></p>*/}
                  {/*</div>*/}
                  <div className="map-address">
                    <div style={{display:'flex'}}>
                      <div className="location-name">{user.results.AppUser.FirstName}</div>
                      <div className="map-distance" style={defaultProps.span} />
                    </div>
                    <p style={defaultProps.address}>{this.formatAddress(user.results.BusinessUser.Address)}</p>
                    <p style={defaultProps.desc}>
                      <span style={defaultProps.infoOffer}>{deals.Title}</span>
                      <span>{(deals.Description && deals.Description!=="") &&` - ${deals.Description}`}</span>
                    </p>
                  </div>

                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}

export default DealSearch;